import { print } from "graphql";
import { Client } from "graphql-ws";
import { getActiveMenuQueryKey } from "./use-get-active-menu";
import { getActiveMenuCategoriesQueryKey } from "./use-get-active-menu-categories";
import { getCurrentLocationQueryKey } from "./use-get-current-location";
import { getCurrentVenueQueryKey } from "./use-get-current-venue";
import { VenueSubscriptionSummaryFragment } from "./fragments/venue-subscription-summary";
import { reconcileCartForRealtimeContext } from "~/libs/realtime";
import {
	GetCurrentLocationQuery,
	GetCurrentVenueQuery,
	SubscribeToCurrentVenueDocument,
	SubscribeToCurrentVenueSubscription,
} from "~/types/__generated/gql/graphql";
import { queryClient } from "~/providers/query-provider";

void (
	/* GraphQL */ `
		subscription SubscribeToCurrentVenue {
			subscribeToCurrentVenue {
				type
				id
				payload {
					...VenueSubscriptionSummary
				}
			}
		}
		${VenueSubscriptionSummaryFragment}
	`
);

export const subscribeToCurrentVenue = (client: Client) =>
	client.subscribe<SubscribeToCurrentVenueSubscription>(
		{ query: print(SubscribeToCurrentVenueDocument) },
		{
			next: async (result) => {
				const event = result.data?.subscribeToCurrentVenue;
				if (event?.type === "delete" || !event?.payload) return;

				const venueQueryKey = getCurrentVenueQueryKey();
				const locationQueryKey = getCurrentLocationQueryKey();
				const prevVenue =
					queryClient.getQueryData<GqlResultOf<GetCurrentVenueQuery>>(
						venueQueryKey,
					);
				const prevLocation =
					queryClient.getQueryData<GqlResultOf<GetCurrentLocationQuery>>(
						locationQueryKey,
					);

				await Promise.all([
					queryClient.invalidateQueries({
						queryKey: venueQueryKey,
						exact: true,
					}),
					queryClient.invalidateQueries({
						queryKey: locationQueryKey,
						exact: true,
					}),
					queryClient.invalidateQueries({
						queryKey: getActiveMenuQueryKey(),
						exact: true,
					}),
					queryClient.invalidateQueries({
						queryKey: getActiveMenuCategoriesQueryKey(),
						exact: true,
					}),
					queryClient.invalidateQueries({
						queryKey: ["getActiveMenuItemsQr"],
					}),
					queryClient.invalidateQueries({
						queryKey: ["getActiveMenuItem"],
					}),
				]);

				reconcileCartForRealtimeContext({
					prevVenue,
					nextVenue: event.payload,
					prevLocation,
					nextLocation: prevLocation,
				});
			},
			error: (error) => console.error(error),
			complete: () => undefined,
		},
	);
